/* Aviso de WhatsApp debajo del Código postal del formulario Releasit (Luminé).
   Solo agrega un párrafo con un enlace. No toca campos, listas de cobertura ni el envío del pedido. */
(function () {
  if (!/^\/products\//.test(location.pathname)) return;

  var WA = 'https://wa.me/524921450884?text=';
  var ID = 'lm-aviso-wa-municipio';

  function nombreProducto() {
    var h1 = document.querySelector('.product__title h1, h1');
    var og = document.querySelector('meta[property="og:title"]');
    var t = (h1 && h1.textContent) || (og && og.content) || '';
    t = t.replace(/\s+/g, ' ').trim();
    return t || 'un producto de Luminé';
  }

  function enlace() {
    var msg = 'Hola Luminé, quiero pedir ' + nombreProducto() +
      ' pero no aparece mi municipio. Mi código postal es: ';
    return WA + encodeURIComponent(msg);
  }

  function crearAviso() {
    var p = document.createElement('p');
    p.id = ID;
    p.style.cssText = 'grid-column:1/-1;margin:6px 2px 10px;font:inherit;font-size:13px;line-height:1.4;color:inherit;opacity:.75;';
    p.appendChild(document.createTextNode('¿No aparece tu municipio? Escríbenos por WhatsApp y te ayudamos con tu pedido 👉 '));
    var a = document.createElement('a');
    a.href = enlace();
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Escríbenos aquí';
    a.style.cssText = 'color:inherit;text-decoration:underline;font-weight:600;';
    p.appendChild(a);
    return p;
  }

  function colocar() {
    var zip = document.querySelector('[name="zip_code"]');
    if (!zip) return;
    var form = zip.closest('form') || document;
    if (form.querySelector('#' + ID)) return;
    // El campo cambia de <input> a <select> al elegir estado: el aviso va después de su contenedor.
    var caja = zip.parentElement;
    while (caja && caja.parentElement && caja.parentElement.querySelectorAll('[name]').length <= 1) {
      caja = caja.parentElement;
    }
    (caja || zip).insertAdjacentElement('afterend', crearAviso());
  }

  new MutationObserver(colocar).observe(document.documentElement, { childList: true, subtree: true });
  colocar();
})();
